// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_i7e","cls2":"Base-cls2_rAW Base-cls1_i7e","expanded":"Base-expanded_Hj_","collapsed":"Base-collapsed_mQK","reply":"Base-reply_H5p","more":"Base-more_ytA"};